
import { Component, Vue } from "vue-property-decorator";
import RecommendMaintenanceQuick from "@/page/factory/recMaintenanceQuick.vue";
import { Getter } from "vuex-class";
@Component
export default class RecommendMaintenanceQuickUser extends RecommendMaintenanceQuick {

  /** 2021-07-28 sh #6989 implements quick mitsumori(priority 2). [START] */
  @Getter("isCanQuickMitsumori", { namespace: "FunctionSetting"} )
  isCanQuickMitsumori: any;

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      if (this.isCanQuickMitsumori) {
        this.$router.push("/user/userMenu");
      } else {
        this.$router.push("/user/reservationnumber");
      }
    });
  }
  /** 2021-07-28 sh #6989 implements quick mitsumori(priority 2). [END] */

}
